import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-equipement',
  templateUrl: './equipement.component.html',
  styleUrls: ['./equipement.component.scss']
})
export class EquipementComponent implements OnInit {

  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  search_name: any;
  closeResult = '';
  p: Number = 1;

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies: any
  public idAgency: any
  public Agency: any
  public search: string = ''
  pageIndex: number = 0;
  pageSize: number = 50;
  lowValue: number = 0;
  highValue: number = 50;
  lengthSociete = 10;
  totalSociete: any;
  public AgenciesTunis: any


  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig
  ) { }

  ngOnInit() {

    this.getEquipements();
  }
  getEquipements() {
    this.agenciesService.getMateriauxEquipement().subscribe((data: any) => {
      this.AgenciesTunis = data
      console.log("liste des équipements", this.AgenciesTunis);
      // Filter agencies where phone_number_commercial is "null"
      this.agencies = this.AgenciesTunis.filter((agency: any) => {
        return agency.phone_number_commercial !== "yes";

      })

    });
  }

  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }
  deleteAgencies(agencie, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          this.AgenciesTunis.splice(i, 1)

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
      }
    });
  }

  // public changePage() 
  // {
  //   this.lengthSociete = this.lengthSociete + 10;
  // }


}











